import React, { useState, useMemo, useEffect } from 'react'
import Moment from 'moment'
import _ from 'lodash'
import {
  ModalHeader,
  ModalBody,
  ListGroupItem,
  ListGroup,
  Row, Col,
  UncontrolledTooltip,
  Button,
  ModalFooter
} from 'reactstrap'
import DatePicker from 'react-datepicker'

import Lang from 'Lang/General'
import { timeToMinutes,  } from 'utils/timeToMinute'

function isValidTimeslots(data) {
  return data.every((slot) =>
    timeToMinutes(slot.end_time) > timeToMinutes(slot.start_time)
  );
}

function OperatingSlotForm({
  lang,
  onClose,
  onSubmit
}) {
  const [tempZone, setTempZone] = useState([])  
  const [timeError, setTimeError] = useState(false);
  

  const errors = useMemo(() => {
    let temp = findOverlappingTimeslots(tempZone)

    return temp
    // return temp
  }, [tempZone])

  useEffect(() => {
    setTimeError(!isValidTimeslots(tempZone))
  }, [tempZone])
  
  function findOverlappingTimeslots(timeslots) {
    const overlaps = [];
  
    if (!Array.isArray(timeslots) || timeslots.length === 0) return overlaps;
  
    // Clone and sort timeslots by start_time
    let sortedSlots = _.cloneDeep(timeslots).sort(
      (a, b) => timeToMinutes(a.start_time) - timeToMinutes(b.start_time)
    );
  
    for (let i = 0; i < sortedSlots.length - 1; i++) {
      const current = sortedSlots[i];
      const next = sortedSlots[i + 1];
  
      // Ensure valid start/end times
      if (timeToMinutes(current.end_time) <= timeToMinutes(current.start_time)) {
        overlaps.push({
          error: "Invalid timeslot: end_time must be greater than start_time",
          timeslot: current,
        });
      }
  
      // Check for overlapping times
      if (timeToMinutes(current.end_time) > timeToMinutes(next.start_time)) {
        overlaps.push({
          overlap_between: [current, next],
        });
      }
    }
  
    return overlaps;
  }

  const onChangeSlot = (slotIndex, context, val) => {
    let temp = _.cloneDeep(tempZone)
    temp[slotIndex][context] = val

    setTempZone(temp)
  }

  const onRemoveSlot = (slotIndex) =>  {
    let temp = _.cloneDeep(tempZone)
    temp.splice(slotIndex, 1)

    setTempZone(temp)
  }

  const onAddSlot = () =>  {
    let temp = _.cloneDeep(tempZone)
    temp.push({
      start_time: '00:00',
      end_time: '01:00'
    })

    setTempZone(temp)
  }

  return (
    <>
      <ModalHeader
        toggle={() => onClose()} 
      >
      </ModalHeader>
      <ModalBody>
        <div style={{ height: 500 }}>
          <ListGroup style={{ maxHeight: "100%", overflow: 'scroll', height: 500 }}>
            <ListGroupItem>
              <Row style={{ padding: '7px 0px' }}>
                <Col md={3}>
                  <span>{Lang['OPERATING_HOUR'][lang]}</span>
                </Col>
                <Col md={9}>
                </Col>
              </Row>
              <hr />
            </ListGroupItem>
            <ListGroupItem>
              <Row>
                <Col md={3}>
                  {Lang['ALL_DAY'][lang]}
                </Col>
                <Col md={9} className="d-flex flex-wrap align-items-center">
                {
                  tempZone.map((zoneChild, zoneIndex) => (
                    <div
                      className={`mb-2 ${
                        timeToMinutes(zoneChild.start_time) > timeToMinutes(zoneChild.end_time) ? 'custom-error-time' : ''
                      }`}
                      style={{ 
                        padding: 5,
                        ... (!_.isEmpty(errors) && 
                        _.findIndex(errors?.[0]?.['overlap_between'], child => (child.start_time === zoneChild.start_time && child.end_time === zoneChild.end_time)) > -1
                      ) ? {
                          border: "1px solid red",
                          borderRadius: 5
                        } : {}
                      }}
                    >
                      <div className="d-flex mb-2 align-items-center" style={{ gap: 10 }}>
                        <DatePicker
                          className={'form-control'}
                          selected={ new Date(`1970-01-01T${ zoneChild.start_time }:00`) }
                          onChange={ val => onChangeSlot(zoneIndex, 'start_time', Moment(val).format('HH:mm'))}
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={ 15 }
                          timeCaption='Time'
                          dateFormat='HH:mm'
                          timeFormat='HH:mm'
                        />
                        <span>{` - `}</span>
                        <DatePicker
                          selected={ new Date(`1970-01-01T${ zoneChild.end_time }:00`) }
                          className={'form-control'}
                          onChange={ val => onChangeSlot(zoneIndex,'end_time', Moment(val).format('HH:mm'))}
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={ 15 }
                          timeCaption='Time'
                          dateFormat='HH:mm'
                          timeFormat='HH:mm'
                        />
                        <>
                          <i 
                            id={ `slot-delete-btn-${zoneIndex}` }
                            className="pe-7s-trash" 
                            style={{ fontSize: '23px', color: '#dc3545' }} 
                            onClick={ () => onRemoveSlot(zoneIndex)}
                          />
                          <UncontrolledTooltip
                            target={ `slot-delete-btn-${zoneIndex}` }
                            placement="top">
                            { Lang[ 'DELETE' ][ lang ] }
                          </UncontrolledTooltip>
                        </>
                      </div>
                    </div>
                  ))
                }
                <i 
                  id={`slot-add-btn-all`}
                  className="pe-7s-plus text-success ml-2" 
                  style={{ fontSize: '23px' }} 
                  onClick={ () => onAddSlot()}
                />
                <UncontrolledTooltip
                  target={ `slot-add-btn-all` }
                  placement="top">
                  { Lang[ 'ADD' ][ lang ] }
                </UncontrolledTooltip>
                </Col>
              </Row>
            </ListGroupItem>
          </ListGroup>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          disabled={!_.isEmpty(errors) || timeError}
          onClick={ () => {
            onSubmit(tempZone)
            onClose()
          }}
        >
          {Lang['SUBMIT'][lang]}
        </Button>
      </ModalFooter>
    </>
  )
}

export default OperatingSlotForm